 
import DailyData from "../../Assets/DailyData/dailyData.svg";
import rightArrow from "../../Assets/HourlyData/rightArrow.svg";
import { Link } from "react-router-dom";
import logoAndTitleFunction from "../../AllFunctions/logoAndTitleFunction";
import { useSelector } from "react-redux";

function DayForcast() {
 

  const { formattedWeather } = useSelector((store) => store.dashboard);
 
  // ========================================formatingTimeAndDate==================================
  const formatingTimeAndDate = (format) => {
    const date = new Date(format);

    // Get the month and day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${month}/${day}`; // Output: "10/17"
  };
  // ========================================formatingTimeAndDate==================================

  return (
    <div className=" bg-primaryBgColor dark:bg-darkModePrimaryBgColor lg:px-3 sm:px-1 py-3 rounded-lg font-semibold  h-full  ">
      {/* ==============header part ========================== */}
      <div className="flex justify-between items-center font-semibold text-blackPrimaryText dark:text-darkModeBlackPrimaryText  py-2  ">
        <div className="flex gap-2">
          <img src={DailyData} alt="" />
          Day Forecast
        </div>
        <Link to="/daily-forcast-table">
          <div className="flex gap-2 items-center bg-cardBgColor dark:bg-darkModeSecondaryBgColor rounded-md px-4 py-0.5 mr-4 border border-gray-200 dark:border-white/10 shadow-sm transition-all duration-300">
            <button>more</button>
            <img width={"6px"} src={rightArrow} alt="" />
          </div>
        </Link>
      </div>
      {/* ==============header part ========================== */}
      {/* ========================= Day Forcast ======================= */}
      <div className=" h-[79vh] overflow-y-scroll text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-semibold custom-scrollbar ">
        {formattedWeather?.slice(0, -1).map((dayPara, index) => (
          <div
            className="flex items-center font-bold text-[12px] justify-between lg:gap-6 lg:px-4 sm:px-1 py-3 bg-cardBgColor dark:bg-darkModeCardBgColor border border-gray-200 dark:border-white/10 rounded-lg my-2 lg:mr-2 sm:mr-1 shadow-sm hover:shadow-md transition-all duration-300"
            key={index}
          >
            <p className="">{formatingTimeAndDate(dayPara.Date_time)}</p>
            <img className=" w-[50px]"  src={logoAndTitleFunction(dayPara).logo} alt="" />
            <p className="  min-w-[60px]  ">{logoAndTitleFunction(dayPara).title}</p>
            <p className="text-[14px] min-w-[90px]  ">{`${Math.trunc(
              dayPara.Tmax
            )}°C / ${Math.trunc(dayPara.Tmin)}°C`}</p>
            {/* <p>{dayPara.title}</p>
            <p>{dayPara.amount}</p> */}
          </div>
        ))}
      </div>
      {/* ========================= Day Forcast ======================= */}
    </div>
  );
}

export default DayForcast;
